var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20,
    viewBox: "0 0 20.001 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,6H.5A.5.5,0,0,1,0,5.5v-3A.5.5,0,0,1,.5,2h3a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,3.5,6ZM1,5H3V3H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,12H.5a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,.5,8h3a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,3.5,12ZM1,11H3V9H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,18H.5a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,.5,14h3a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,3.5,18ZM1,17H3V15H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,4.5H6.5a.5.5,0,0,1,0-1h13a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,10.5H6.5a.5.5,0,0,1,0-1h13a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,16.5H6.5a.5.5,0,0,1,0-1h13a.5.5,0,0,1,0,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/ListView.3d9d410a32ca36d97b323a7cadb32b18.svg";
export { ForwardRef as ReactComponent };